import type {
  RouteLocation,
  RouteLocationNormalized,
  RouteRecordRaw,
} from "vue-router";
import type { Acl, User } from "vue-simple-acl/types/acl";
import { BREADCRUMBS } from "~/core/constants/breadcrumbs";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import SectorTreeView from "~/modules/sector/components/SectorTreeView.vue";
import {
  PATH_SECTORS,
  PATH_SECTORS_CODE,
  PATH_SECTORS_CODE_DTWINS,
  PATH_SECTORS_CODE_GROUPS,
  PATH_SECTORS_CODE_SECTORS,
  PATH_SECTORS_CODE_USERS,
} from "~/modules/sector/constants";
import { router } from "~/plugins/router";

const routes: RouteRecordRaw[] = [
  {
    path: PATH_SECTORS,
    component: () => import("~/modules/sector/views/SectorsPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_SECTOR),
      breadcrumb: BREADCRUMBS.SECTOR,
      layout: "DefaultLayout",
      extraAsideComponent: SectorTreeView,
    },
  },
  {
    path: PATH_SECTORS_CODE,
    redirect: (to: RouteLocation) =>
      router.resolve({
        name: PATH_SECTORS_CODE_SECTORS,
        params: { code: to.params.code },
      }),
  },
  {
    path: PATH_SECTORS_CODE_SECTORS,
    component: () => import("~/modules/sector/views/SectorPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_SECTOR),
      breadcrumb: BREADCRUMBS.SECTOR,
      layout: "DefaultLayout",
      extraAsideComponent: SectorTreeView,
    },
  },
  {
    path: PATH_SECTORS_CODE_DTWINS,
    component: () => import("~/modules/sector/views/SectorPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.SECTOR,
      layout: "DefaultLayout",
      extraAsideComponent: SectorTreeView,
    },
  },
  {
    path: PATH_SECTORS_CODE_USERS,
    component: () => import("~/modules/sector/views/SectorPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_USER),
      breadcrumb: BREADCRUMBS.SECTOR,
      layout: "DefaultLayout",
      extraAsideComponent: SectorTreeView,
    },
  },
  {
    path: PATH_SECTORS_CODE_GROUPS,
    component: () => import("~/modules/sector/views/SectorPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_USER),
      breadcrumb: BREADCRUMBS.SECTOR,
      layout: "DefaultLayout",
      extraAsideComponent: SectorTreeView,
    },
  },
];

export default routes;
